import React from 'react'
import { Button, Input, Tooltip } from 'antd'
import { SendOutlined, StopOutlined } from '@ant-design/icons'

const ChatInput = ({
  text,
  setText,
  isStreaming,
  onSubmit,
  onStop
}) => {
  const handleInputSubmit = () => {
    if (!text.trim() || isStreaming) return
    onSubmit(text)
    setText('')
  }

  const handleKeyPress = (e) => {
    if (!e.shiftKey) {
      e.preventDefault()
      handleInputSubmit()
    }
  }

  const handleFocus = (e) => {
    e.target.parentElement.style.borderColor = '#ad0270'
    e.target.parentElement.style.background = '#ffffff'
  }

  const handleBlur = (e) => {
    e.target.parentElement.style.borderColor = '#d1d5db'
    e.target.parentElement.style.background = '#f8fafc'
  }

  return (
    <div style={{
      background: '#ffffff',
      borderTop: '1px solid #e5e7eb',
      padding: '16px 24px',
      flexShrink: 0
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{
          position: 'relative',
          background: '#f8fafc',
          border: '1px solid #d1d5db',
          borderRadius: '24px',
          transition: 'all 0.2s ease'
        }}>
          <Input.TextArea
            rows={1}
            placeholder="Message Kolumbus.ai..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onPressEnter={handleKeyPress}
            autoSize={{ minRows: 1, maxRows: 4 }}
            variant="borderless"
            disabled={isStreaming}
            style={{
              fontSize: '16px',
              lineHeight: '1.5',
              padding: '12px 50px 12px 20px',
              resize: 'none',
              background: 'transparent'
            }}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />

          <div style={{
            position: 'absolute',
            right: '8px',
            bottom: '8px'
          }}>
            {isStreaming ? (
              <Tooltip title="Stop generating">
                <Button
                  type="text"
                  shape="circle"
                  size="small"
                  icon={<StopOutlined style={{ fontSize: '14px' }} />}
                  onClick={onStop}
                  style={{
                    width: '28px',
                    height: '28px',
                    background: '#fee2e2',
                    border: '1px solid #fecaca',
                    color: '#dc2626'
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Send message">
                <Button
                  type="text"
                  shape="circle"
                  size="small"
                  icon={<SendOutlined style={{ fontSize: '14px' }} />}
                  disabled={!text.trim()}
                  onClick={handleInputSubmit}
                  style={{
                    width: '28px',
                    height: '28px',
                    background: text.trim() ? '#ad0270' : '#e5e7eb',
                    border: 'none',
                    color: text.trim() ? '#ffffff' : '#9ca3af'
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatInput